/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, {
  forwardRef,
  useRef,
  useImperativeHandle,
  Fragment,
  useState,
  useEffect,
} from "react";
import { sanitizeImageUrl } from "../../utils/sanitizeImageUrl";
import { Row, Col } from "react-bootstrap";
import { FaEuroSign } from "react-icons/fa";
import ImageGallery from "react-image-gallery";
// import Magnifier from '../Magnifer/index'
import Table from "react-bootstrap/Table";
import {
  MdArrowCircleUp,
  MdAutorenew,
  MdChevronLeft,
  MdChevronRight,
} from "react-icons/md";

import { useContext } from "react";
import FeedbackContext from "../../context/cmscontext";
import {
  AiFillCaretUp,
  AiFillCaretDown,
  AiFillHeart,
  AiOutlineHeart,
} from "react-icons/ai";
import { Divider } from "semantic-ui-react";
import TabExamplePointing from "./tabbar";
import Graph from "../Product View/graph";
import $ from "jquery";
import { connect, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import Labels from "../../services/apiLabels";
import ScaleLoader from "react-spinners/ScaleLoader";
import Magnify from "./magnify";
import "./Productview.css";
import "./ProductDetail.css";
// import "./style.css";
// import "../../components/Magnifer/magnifier.css";
import Event from "../../components/Magnifer/Event";
import Magnifier from "../../components/Magnifer/Magnifier";
import {
  getProductCodeFromLocation,
  getListingPreviewFromLocation,
} from "../../utils/productLocation";
import {
  PLACE_BID,
  PRODUCT_DETAIL,
  TOASTER_SHOW,
  toaster_w,
  APPROXY_BID_NEW,
  TIMER_DATA_UPDATE,
  SHIPING_COST,
} from "../../constant";
import { GET, POST } from "../../constant/apiMethods";
import carSvg from "../../assets/svg/car.svg";
import ProductMainShimmer from "./ProductMainShimmer";
import Tabs from "../TabsComponent";
import SlideButton from "../SlideButton";
import Carousel from "../Carousel";
import BidDetailsModal from "./BidDetailModel";
import {
  ClipboardDocumentCheckIcon,
  ClipboardDocumentListIcon,
} from "@heroicons/react/24/outline";
import VehicleDetailsGrid from "./detailsGrid";
function ProductMain(props) {
  const {
    product,
    getProductDetail,
    place_bid,
    toasterShow,
    loadingPlaceBid,
    user_id,
    loadingDetails,
    approxy_BidNew,
    shiping_cost_calclate,
    shiping_coast_,
    loading,
    costData,
    updatetimerdata,
    product_new,
    product_chk,
  } = props;
  const graphRef = useRef();

  const { feedback, isLoading } = useContext(FeedbackContext);
  const data = useSelector((state) => state.product);
  const [bidStatus, setBidStatus] = useState("");
  const [isRotating, setIsRotating] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [color, setColor] = useState(false);
  const handleClose = () => setShowModal(false);
  if (data?.message?.description) {
  }
  var auction_page = feedback.auction_page;
  let location = useLocation();
  let history = useHistory();
  useEffect(() => {
    // if(location.state){
    //   const { product_code } = location.state;
    // }
  }, []);

  const [bidInputValue, setBidInputValue] = useState(0);
  const [bidInputFormated, setbidInputFormated] = useState({
    focused: false,
    formated: "0",
  });
  const [graphData, setGraphData] = useState({});
  const [bidingExpired, setBidingExpired] = useState(true);
  const [timer, setTimer] = useState([
    { id: "days", value: "00" },
    { id: "hours", value: "00" },
    { id: "minutes", value: "00" },
    { id: "seconds", value: "00" },
  ]);
  const [images, setImages] = useState([]);
  const [slideIndex, setSlideIndex] = useState(0);
  const [current_image, setcurrent_image] = useState("");
  // place bid inputs functions
  let bidAmountID = parseInt(product?.increment_value) || 100;
  let [currentBid, setcurrentBid] = useState(0);
  const imageGalleryDataFormatter = (arr) => {
    let formattedArr = [];

    // arr.map((item) => {
    //   return formattedArr.push({
    //     image: item,
    //   });
    // });
    React.Children.toArray(
      arr.map((item, index) => {
        const clean = sanitizeImageUrl(item);
        return formattedArr.push({
          original: clean,
          thumbnail: clean,
          id: index + 1,
        });
      })
    );
    //

    setImages(formattedArr);
  };
  const [isdone, setisdone] = useState(false);
  const [new_bid_a, setnew_bid_a] = useState(0);
  const [postCode, setpostCode] = useState("");
  const [shippingError, setShippingError] = useState("");
  const shippingPending = useRef(false);
  const pickupPostcode = product?.post_code || product?.postcode || "";
  const hasShippingQuote = Array.isArray(costData) && costData.length > 0;
  // price formater adding commas
  function priceFormater(numb) {
    var str = numb.toString();
    return str.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  // car animate handler
  // const carAnimationHandler = () => {
  //   document.getElementById("animating_car_cont").className =
  //     "bid_animating_car_cont";
  //   setTimeout(() => {
  //     document.getElementById("animating_car_cont").className = "d-none";
  //   }, 3000);
  // };
  const productCode = getProductCodeFromLocation(location);
  const bidPreview = getListingPreviewFromLocation(location);

  // Keep product id in the URL so refresh does not lose it (and bounce to auction).
  useEffect(() => {
    if (!productCode) return;
    const params = new URLSearchParams(location.search || "");
    if (params.get("id") === String(productCode)) return;
    history.replace({
      pathname: location.pathname,
      search: `?id=${encodeURIComponent(productCode)}`,
      state: {
        ...(location.state || {}),
        product_code: productCode,
      },
    });
  }, [productCode, location.pathname, location.search, location.state, history]);

  useEffect(() => {
    if (productCode) {
      getProductDetail(productCode);
    }
  }, [productCode]);

  useEffect(() => {
    if (product?.images) imageGalleryDataFormatter(product.images);
    if (product?.start_price) {
      bidInputOnChangeHandler(
        product.start_price + parseInt(product?.increment_value)
      );
      setcurrentBid(product.start_price);
    }
    if (product?.increment_value) {
      bidAmountID = parseInt(product?.increment_value) || 100;
    }

    //
  }, [product]);
  useEffect(() => {
    if (!shippingPending.current || loading) return;
    shippingPending.current = false;
    if (!hasShippingQuote) {
      setShippingError(
        "Shipping quotes are unavailable right now. Please try again later."
      );
    }
  }, [loading, hasShippingQuote]);
  // graph data handler
  useEffect(() => {
    updatetimerdata({
      end_at: graphData.end_at,
    });

    //

    let currentBidAmmount = graphData.cur_bid;
    if (currentBidAmmount) {
      if (currentBidAmmount > currentBid) {
        bidInputOnChangeHandler(
          currentBidAmmount + parseInt(product?.increment_value)
        );
        setcurrentBid(currentBidAmmount);
        // carAnimationHandler();
      }
    }
  }, [graphData]);
  var evt = new Event();
  var m = new Magnifier(evt, {});
  // useEffect(() => {
  // // console.log
  //   "tag class ",
  //   document.getElementsByClassName(".center")[0].getElementsByTagName("img")[0]
  // );
  //   if (!isdone) {
  //     setisdone(true);
  //     m = new Magnifier(evt, {
  //       largeWrapper: document.getElementById("zoom-preview"),
  //     });

  //     m.attach({
  //       thumb: document
  //         .getElementsByClassName(".center")[0]
  //         .getElementsByTagName("img")[0],
  //       large: current_image,
  //       largeWrapper: "zoom-preview",
  //       zoom: 2,
  //       mode: "inside",
  //       zoomable: true,
  //       onthumbenter: function () {
  //         // document.getElementById("enter").innerHTML = "Mouse enter";
  //         // document.getElementById("leave").innerHTML = "";
  //         // document.getElementById("zoom").innerHTML = "";
  //         document.getElementById("zoom-preview").classList.remove("d-none");
  //       },
  //       onthumbmove: function () {
  //         // document.getElementById("move").innerHTML = "Mouse move";
  //         document.getElementById("zoom-preview").classList.remove("d-none");
  //       },
  //       onthumbleave: function () {
  //         // document.getElementById("enter").innerHTML = "";
  //         // document.getElementById("move").innerHTML = "";
  //         // document.getElementById("zoom").innerHTML = "";
  //         // document.getElementById("leave").innerHTML = "Mouse leave";
  //         document.getElementById("zoom-preview").classList.add("d-none");
  //       },
  //       // onzoom: function (data) {
  //       //   document.getElementById("zoom").innerHTML = "Zoom: " + data.zoom;
  //       // },
  //     });
  //   } else {
  //     m.setThumb(
  //       document
  //         .getElementsByClassName(".center")[0]
  //         .getElementsByTagName("img")[0]
  //     );
  //   }
  // }, [current_image]);
  // --------------timer
  // let countDownDate = new Date().getTime() + 10000;
  //
  const timeFormatter = (e) => {
    return e < 10 ? `0${e}` : e;
  };
  const screen_change = (e) => {
    m.leaver();
    document.getElementById("zoom-preview").classList.add("d-none");
    //

    if (e) {
      //
      m.attach({
        thumb: ".image-gallery-image",
        // document
        //   .getElementsByClassName("center")[0]
        //   .getElementsByTagName("img")[0],
        // large: current_image,
        largeWrapper: "zoom-preview",
        zoom: 2,
        mode: "inside",
        zoomable: true,
        onthumbenter: function () {
          // document.getElementById("enter").innerHTML = "Mouse enter";
          // document.getElementById("leave").innerHTML = "";
          // document.getElementById("zoom").innerHTML = "";
          // document.getElementById("zoom-preview").classList.remove("d-none");
        },
        onthumbmove: function () {
          // document.getElementById("move").innerHTML = "Mouse move";
          // document.getElementById("zoom-preview").classList.remove("d-none");
        },
        onthumbleave: function () {
          // document.getElementById("enter").innerHTML = "";
          // document.getElementById("move").innerHTML = "";
          // document.getElementById("zoom").innerHTML = "";
          // document.getElementById("leave").innerHTML = "Mouse leave";
          // document.getElementById("zoom-preview").classList.add("d-none");
        },
        // onzoom: function (data) {
        //   document.getElementById("zoom").innerHTML = "Zoom: " + data.zoom;
        // },
      });
    } else {
      //
      m.attach({
        thumb: ".image-gallery-image",
        // document
        //   .getElementsByClassName("center")[0]
        //   .getElementsByTagName("img")[0],
        // large: current_image,
        largeWrapper: "zoom-preview",
        zoom: 2,
        mode: "inside",
        zoomable: true,
        onthumbenter: function () {
          // document.getElementById("enter").innerHTML = "Mouse enter";
          // document.getElementById("leave").innerHTML = "";
          // document.getElementById("zoom").innerHTML = "";
          var ab = document.getElementById("zoom-preview");
          if (ab) {
            ab.classList.remove("d-none");
          }
          // document.getElementById("zoom-preview").classList.remove("d-none");
        },
        onthumbmove: function () {
          // document.getElementById("move").innerHTML = "Mouse move";
          var ab = document.getElementById("zoom-preview");
          if (ab) {
            ab.classList.remove("d-none");
          }
          // document.getElementById("zoom-preview").classList.remove("d-none");
        },
        onthumbleave: function () {
          // document.getElementById("enter").innerHTML = "";
          // document.getElementById("move").innerHTML = "";
          // document.getElementById("zoom").innerHTML = "";
          // document.getElementById("leave").innerHTML = "Mouse leave";
          var ab = document.getElementById("zoom-preview");
          if (ab) {
            ab.classList.add("d-none");
          }
        },
        // onzoom: function (data) {
        //   document.getElementById("zoom").innerHTML = "Zoom: " + data.zoom;
        // },
      });
    }
    m.set_data();
    //  m = new Magnifier(evt, {
    //    largeWrapper: document.getElementById("zoom-preview"),
    //  });
    // m.setThumb(document
    //         .getElementsByClassName("center")[0]
    //         .getElementsByTagName("img")[0]);
  };
  const set_magnifier = (e) => {
    if (!isdone) {
      setisdone(true);
      // m = new Magnifier(evt, {
      //   largeWrapper: document.getElementById("zoom-preview"),
      // });
      m.attach({
        thumb: ".image-gallery-image",
        // document
        //   .getElementsByClassName("center")[0]
        //   .getElementsByTagName("img")[0],
        // large: current_image,
        largeWrapper: "zoom-preview",
        zoom: 2,
        mode: "inside",
        zoomable: true,
        onthumbenter: function () {
          // document.getElementById("enter").innerHTML = "Mouse enter";
          // document.getElementById("leave").innerHTML = "";
          // document.getElementById("zoom").innerHTML = "";
          var ab = document.getElementById("zoom-preview");
          if (ab) {
            ab.classList.remove("d-none");
          }
          // document.getElementById("zoom-preview").classList.remove("d-none");
        },
        onthumbmove: function () {
          // document.getElementById("move").innerHTML = "Mouse move";
          var ab = document.getElementById("zoom-preview");
          if (ab) {
            ab.classList.remove("d-none");
          }
          // document.getElementById("zoom-preview").classList.remove("d-none");
        },
        onthumbleave: function () {
          //
          // document.getElementById("enter").innerHTML = "";
          // document.getElementById("move").innerHTML = "";
          // document.getElementById("zoom").innerHTML = "";
          // document.getElementById("leave").innerHTML = "Mouse leave";
          var ab = document.getElementById("zoom-preview");
          if (ab) {
            ab.classList.add("d-none");
          }
          // document.getElementById("zoom-preview").classList.add("d-none");
        },
        // onzoom: function (data) {
        //   document.getElementById("zoom").innerHTML = "Zoom: " + data.zoom;
        // },
      });
    }
  };
  const convertTime = (date) => {
    const dateString = date;
    const userOffset = new Date().getTimezoneOffset() * 60 * 1000;
    const localDate = new Date(dateString);
    const utcDate = new Date(localDate.getTime() + userOffset);
    return utcDate;
  };
  useEffect(() => {
    // // console.log"product now =====>> ",product_new )
    let countDownDate = new Date(
      product_new.end_at ? convertTime(product_new.end_at) : 0
    ).getTime();
    const interval = setInterval(function () {
      // Get today's date and time
      var now = new Date().getTime();

      // Find the distance between now and the count down date
      var distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      setTimer([
        { id: "days", value: timeFormatter(days) },
        { id: "hours", value: timeFormatter(hours) },
        { id: "minutes", value: timeFormatter(minutes) },
        { id: "seconds", value: timeFormatter(seconds) },
      ]);
      setBidingExpired(false);
      // If the count down is over, write some text
      if (distance < 0) {
        // // console.log"distancedistancedistance",distance)
        clearInterval(interval);
        setBidingExpired(true);
        setTimer([
          { id: "days", value: "00" },
          { id: "hours", value: "00" },
          { id: "minutes", value: "00" },
          { id: "seconds", value: "00" },
        ]);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [product_new]);
  // --------------timer

  // ==========aprocxy bid==========

  const approxy_bid = async () => {
    let obj = {
      date: new Date(),
      auction_id: product.auction_id,
      user_id,
      bid_amount: new_bid_a,
      bid_type: "2",
    };

    approxy_BidNew(obj);
    await graphRef.current.fetchGraphData();
    return "bid placed";
  };

  // place bid handler
  const placeBidHandler = async () => {
    console.log("current bid--->> ", currentBid);
    if (bidInputValue > currentBid) {
      let obj = {
        date: new Date(),
        auction_id: product.auction_id,
        user_id,
        bid_amount: bidInputValue,
        bid_type: "1",
      };
      //
      try {
        await place_bid(obj);
        await graphRef.current.fetchGraphData();
        setColor(true);

        setBidStatus("Bid Placed Successfully");
        setTimeout(() => {
          setBidStatus("");
        }, 5000);
        return "bid placed";
      } catch (err) {
        console.log(err);
        setColor(false);
        setBidStatus("You cannot bid lower then the bid going on");
        setTimeout(() => {
          setBidStatus("");
        }, 5000);
      }
    } else {
      toasterShow({
        type: toaster_w,
        description: `Bidding amount must be greater then ${currentBid}`,
      });
      setColor(false);
      setBidStatus(`Bidding amount must be greater then ${currentBid}`);
      setTimeout(() => {
        setBidStatus("");
      }, 5000);
      return "bid not placed";
    }
  };
  const fetchGraphHandler = async () => {
    setIsRotating(true);
    await graphRef.current.fetchGraphData();
    setTimeout(() => {
      setIsRotating(false);
    }, 3000);
  };
  const bidInputOnChangeHandler = (e) => {
    if (e) {
      setBidInputValue(e);
      setbidInputFormated({ ...bidInputFormated, formated: priceFormater(e) });
    }
  };
  const bidInputOnChangeHandler2 = (e) => {
    if (e) {
      setnew_bid_a(e);
      // setbidInputFormated({ ...bidInputFormated, formated: priceFormater(e) });
    }
  };
  const vehicleDetails = [
    { name: "Make", value: product?.product_name },
    { name: "Model", value: product?.model_name },
    { name: "Year", value: product?.year },
    { name: "Mileage", value: product?.Mileage },
    { name: "Fuel Type", value: product?.fuel_type },
    {
      name: "Transmission",
      value:
        product?.Transmission == 1
          ? "Auto"
          : product?.Transmission == 2
          ? "Manual"
          : "Both",
    },
    {
      name: "Body Type",
      value:
        product?.car_body_type == 1
          ? "Hatchback"
          : product?.car_body_type == 2
          ? "MPV"
          : product?.car_body_type == 3
          ? "SUV"
          : "Saloon",
    },
    { name: "Registration", value: product?.Registration },
    { name: "VAT", value: product?.vat },
  ];
  // ================shiping valculate=============

  const calculate_ = () => {
    const destination = postCode.trim();
    if (!destination) {
      setShippingError("Enter your postcode to get a shipping quote.");
      return;
    }
    if (!pickupPostcode) {
      setShippingError(
        "This lot has no pickup postcode yet, so shipping cannot be calculated."
      );
      return;
    }
    if (loading) return;
    setShippingError("");
    shippingPending.current = true;
    shiping_cost_calclate({
      position1: pickupPostcode,
      position2: destination,
      t_type: "open",
      pickup: false,
      type_of_car: "SUV",
      premium: false,
    });
  };

  // document
  //   .getElementByClassName("image-gallery-fullscreen-button")[0]
  //   .addEventListener("click", changeObjectFitHandler);
  // function changeObjectFitHandler() {
  //   let image = document.getElementsByClassName("img")[0];
  //   let style = window.getComputedStyle(image);
  //   let objectFit = style.getPropertyValue("object-fit");
  //   if (objectFit === "contain") {
  //     image.style.objectFit = "cover";
  //   }
  //   if (objectFit === "cover") {
  //     image.style.objectFit = "contain";
  //   }
  //
  // }
  const money = (value) =>
    `€${Number(value || 0).toLocaleString(undefined, {
      maximumFractionDigits: 0,
    })}`;
  const incrementValue = parseInt(product?.increment_value) || 0;
  const liveBid = Number(graphData?.cur_bid || currentBid || 0);
  const minimumNextBid = liveBid + incrementValue;
  // Under an hour left: highlight the countdown.
  const timerUrgent =
    !bidingExpired &&
    timer[0]?.value === "00" &&
    timer[1]?.value === "00";

  const hasProductDetail = Boolean(
    product &&
      (product.id ||
        product.product_name ||
        product.auction_id ||
        (Array.isArray(product.images) && product.images.length))
  );

  // loadingDetails
  if (loadingDetails) {
    return <ProductMainShimmer />;
  }

  const goBack = () => {
    if (history.length > 1) history.goBack();
    else history.push("/dealers/dashbord");
  };

  const pageClass = "dp-page dp-page--embedded";

  // product_detail often fails (ended lots / API errors) — show list snapshot instead of bouncing away
  if (!productCode) {
    return (
      <Fragment>
        <div className={pageClass}>
          <div className="dp-page__inner">
            <header className="dp-topbar">
              <button type="button" className="dp-btn dp-btn--ghost" onClick={goBack}>
                ← Back
              </button>
              <div className="dp-topbar__meta">
                <span className="dp-chip">Auction</span>
              </div>
            </header>
            <div className="dp-panel dp-empty">
              <h1 className="dp-empty__title">No lot selected</h1>
              <p className="dp-empty__text">
                Open a listing from favourites, watchlist, or the auction floor.
              </p>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }

  if (!hasProductDetail) {
    const reg =
      bidPreview?.registration ||
      product?.Registration ||
      product?.registration ||
      "—";
    const vehicle =
      bidPreview?.product_name ||
      bidPreview?.vehicle ||
      product?.product_name ||
      "Vehicle details unavailable";
    const price = bidPreview?.product_price;
    return (
      <Fragment>
        <div className={pageClass}>
          <div className="dp-page__inner">
            <header className="dp-topbar">
              <button type="button" className="dp-btn dp-btn--ghost" onClick={goBack}>
                ← Back
              </button>
              <div className="dp-topbar__meta">
                <span className="dp-chip">Auction</span>
              </div>
            </header>
            <div className="dp-panel dp-empty">
              <div className="dp-plate">
                <span className="dp-plate__badge" aria-hidden>
                  ATP
                </span>
                <div className="dp-plate__text">{String(reg).toUpperCase()}</div>
              </div>
              <h1 className="dp-empty__title">{vehicle}</h1>
              <p className="dp-empty__text">
                Full listing details could not be loaded for this lot.
                Showing the summary from your list where available.
              </p>
              <table className="dp-summary">
                <tbody>
                  {price != null && price !== "" ? (
                    <tr>
                      <th>Price</th>
                      <td>€{Number(price).toLocaleString()}</td>
                    </tr>
                  ) : null}
                  {bidPreview?.myBidOffer != null ? (
                    <tr>
                      <th>Your offer</th>
                      <td>€{Number(bidPreview.myBidOffer).toLocaleString()}</td>
                    </tr>
                  ) : null}
                  {bidPreview?.winningBid != null ? (
                    <tr>
                      <th>Winning bid</th>
                      <td>€{Number(bidPreview.winningBid).toLocaleString()}</td>
                    </tr>
                  ) : null}
                  {bidPreview?.status != null ? (
                    <tr>
                      <th>Status</th>
                      <td>{String(bidPreview.status)}</td>
                    </tr>
                  ) : null}
                  {bidPreview?.bidOffer != null ? (
                    <tr>
                      <th>Date</th>
                      <td>{new Date(bidPreview.bidOffer).toLocaleString()}</td>
                    </tr>
                  ) : null}
                  {bidPreview?.product_description ? (
                    <tr>
                      <th>Description</th>
                      <td>{String(bidPreview.product_description)}</td>
                    </tr>
                  ) : null}
                  {productCode != null ? (
                    <tr>
                      <th>Product ID</th>
                      <td>{String(productCode)}</td>
                    </tr>
                  ) : null}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }

  const reserveTone =
    graphData.cur_bid >= graphData.lowest_price
      ? "dp-reserve--ok"
      : (graphData.cur_bid / graphData.lowest_price) * 100 < 80
      ? "dp-reserve--bad"
      : "dp-reserve--warn";
  const bidderCount = Array.isArray(product?.bids_detail)
    ? product.bids_detail.length
    : 0;

  return (
      <Fragment>
        <div className={pageClass}>
          <div className="dp-page__inner">
            <header className="dp-topbar">
              <button type="button" className="dp-btn dp-btn--ghost" onClick={goBack}>
                ← Back
              </button>
              <div className="dp-topbar__meta">
                <span className="dp-chip">Auction</span>
              </div>
            </header>

            <div className="dp-hero">
              <div className="dp-panel">
                <section className="dp-media">
                  <header className="dp-media__head">
                    <div>
                      <p className="dp-media__eyebrow">Lot gallery</p>
                      <h3 className="dp-media__title">Vehicle photos</h3>
                    </div>
                    <span className="dp-media__counter">
                      {images.length
                        ? `${Math.min(slideIndex + 1, images.length)} / ${
                            images.length
                          }`
                        : "No photos"}
                    </span>
                  </header>
                  <div className="dp-gallery slider_">
                    {images.length ? (
                      <ImageGallery
                        lazyLoad={false}
                        onImageLoad={set_magnifier}
                        onSlide={setSlideIndex}
                        startIndex={0}
                        items={images}
                        showBullets={false}
                        showPlayButton={false}
                        showFullscreenButton={false}
                        showIndex={false}
                        thumbnailPosition="bottom"
                        slideDuration={320}
                        originalClass="ImageGallery_originalClass"
                        renderLeftNav={(onClick, disabled) => (
                          <button
                            type="button"
                            className="dp-gallery__nav dp-gallery__nav--prev"
                            onClick={onClick}
                            disabled={disabled}
                            aria-label="Previous photo"
                          >
                            <MdChevronLeft size={24} aria-hidden />
                          </button>
                        )}
                        renderRightNav={(onClick, disabled) => (
                          <button
                            type="button"
                            className="dp-gallery__nav dp-gallery__nav--next"
                            onClick={onClick}
                            disabled={disabled}
                            aria-label="Next photo"
                          >
                            <MdChevronRight size={24} aria-hidden />
                          </button>
                        )}
                      />
                    ) : (
                      <p className="dp-gallery__empty">
                        No photos have been uploaded for this lot yet.
                      </p>
                    )}
                    <div
                      className="magnifier-preview d-none"
                      id="zoom-preview"
                      aria-hidden="true"
                    />
                  </div>
                </section>
                <div className="dp-shipping">
                  <h3 className="dp-panel__title">{auction_page.Shiping_Charges}</h3>
                  <p className="dp-panel__hint">{auction_page.Enter_Your_Post_Code}</p>
                  <div className="dp-shipping__row">
                    <input
                      value={postCode}
                      onChange={(e) => {
                        setShippingError("");
                        setpostCode(e.target.value);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") calculate_();
                      }}
                      className="dp-input"
                      aria-label="Delivery postcode"
                      aria-invalid={shippingError ? "true" : "false"}
                      placeholder={auction_page.LEG321_placeholder}
                    />
                    <button
                      type="button"
                      className="dp-btn dp-btn--primary"
                      onClick={calculate_}
                      disabled={loading || !postCode.trim()}
                    >
                      {loading
                        ? auction_page.Calculating_button_placeholder
                        : auction_page.Calculate_button_placeholder}
                    </button>
                  </div>
                  {pickupPostcode ? (
                    <p className="dp-panel__hint dp-shipping__from">
                      Quoted from pickup postcode {pickupPostcode}.
                    </p>
                  ) : null}
                  {shippingError ? (
                    <p className="dp-shipping__error" role="alert">
                      {shippingError}
                    </p>
                  ) : null}
                  {hasShippingQuote ? (
                    <table className="dp-cost-table">
                      <tbody>
                        {React.Children.toArray(
                          costData.map((item) => (
                            <Fragment>
                              <tr>
                                <td>{item.title}</td>
                              </tr>
                              <tr>
                                <td>
                                  {Math.floor(item.price)}
                                  <span className="uero">€</span>
                                </td>
                              </tr>
                            </Fragment>
                          ))
                        )}
                      </tbody>
                    </table>
                  ) : null}
                </div>
              </div>

              <div className="dp-aside">
                <div className="dp-panel cardetailmain">
                  <div className="dp-identity">
                    {product?.brands_image ? (
                      <img
                        src={sanitizeImageUrl(product?.brands_image)}
                        className="dp-identity__brand"
                        alt=""
                      />
                    ) : null}
                    <div className="dp-plate">
                      <span className="dp-plate__badge" aria-hidden>
                        ATP
                      </span>
                      <div className="dp-plate__text">
                        {(
                          product?.Registration ||
                          product?.registration ||
                          bidPreview?.registration ||
                          "—"
                        )
                          .toString()
                          .toUpperCase()}
                      </div>
                    </div>
                    <h1 className="dp-identity__title">
                      {`${product?.product_name || ""} ${product?.year || ""} ${
                        product?.fuel_type || ""
                      }`.trim()}
                    </h1>
                  </div>

                  <div className="dp-bid">
                    <div className="dp-bid__summary">
                      <div className="dp-bid__figure">
                        <span className="dp-bid__figure-label">Current bid</span>
                        <span className="dp-bid__figure-value">
                          {money(liveBid)}
                        </span>
                      </div>
                      <dl className="dp-bid__meta">
                        <div>
                          <dt>Min next bid</dt>
                          <dd>{money(minimumNextBid)}</dd>
                        </div>
                        <div>
                          <dt>Increment</dt>
                          <dd>{money(incrementValue)}</dd>
                        </div>
                      </dl>
                    </div>
                    <div className="counter_main_container flex-column d-flex justify-content-center align-items-center align-self-center">
                      <p
                        className={`dp-timer__title${
                          bidingExpired ? " is-ended" : ""
                        }`}
                      >
                        {bidingExpired ? "Auction ended" : "Auction ends in"}
                      </p>
                      <div
                        className={`dp-timer${
                          timerUrgent ? " is-urgent" : ""
                        }${bidingExpired ? " is-ended" : ""}`}
                      >
                        {React.Children.toArray(
                          timer.map((item, index) => (
                            <Fragment>
                              <span className="dp-timer__cell">
                                <div className="dp-timer__value">{item.value}</div>
                                <span className="dp-timer__label">{item.id}</span>
                              </span>
                              {index === timer.length - 1 ? null : (
                                <span className="dp-timer__sep">:</span>
                              )}
                            </Fragment>
                          ))
                        )}
                      </div>
                      <Tabs
                        data={[
                          {
                            label: `${auction_page.Place_Bid_text}`,
                            component: (
                              <span>
                                {/* place bid container */}
                                <div
                                  // style={{ height: "40px", margin: "5%" }}
                                  className="place_bid_input_cont"
                                >
                                  {/* car animation */}
                                  <div
                                    id="animating_car_cont"
                                    className="d-none"
                                  >
                                    <img
                                      className="bid_animating_car"
                                      src={carSvg}
                                      alt="car..."
                                    />
                                  </div>
                                  {/* ////////////// car animation */}
                                  <Fragment>
                                    <input
                                      disabled={
                                        loadingPlaceBid || bidingExpired
                                      }
                                      value={
                                        bidInputFormated.focused
                                          ? bidInputValue
                                          : bidInputFormated.formated
                                      }
                                      onChange={(e) =>
                                        bidInputOnChangeHandler(e.target.value)
                                      }
                                      onFocus={() =>
                                        setbidInputFormated({
                                          ...bidInputFormated,
                                          focused: true,
                                        })
                                      }
                                      onBlur={(e) => {
                                        if (bidInputValue < currentBid) {
                                          setBidInputValue(currentBid);
                                          setbidInputFormated({
                                            focused: false,
                                            formated: priceFormater(currentBid),
                                          });
                                        } else {
                                          setbidInputFormated({
                                            ...bidInputFormated,
                                            focused: false,
                                          });
                                        }
                                      }}
                                      // className="bg_red"
                                      placeholder="Place Your Bid"
                                      aria-label="Your bid amount in euro"
                                      aria-describedby="dp-bid-hint"
                                    />
                                    <div className="d-flex flex-column">
                                      <button
                                        disabled={
                                          loadingPlaceBid || bidingExpired
                                        }
                                        onClick={() =>
                                          bidInputOnChangeHandler(
                                            parseInt(bidInputValue) +
                                              bidAmountID
                                          )
                                        }
                                        className="d-flex justify-content-center align-items-center  incrementDecrementBtn"
                                      >
                                        <AiFillCaretUp />
                                      </button>
                                      <button
                                        disabled={
                                          loadingPlaceBid || bidingExpired
                                        }
                                        onClick={() => {
                                          const decVal =
                                            parseInt(bidInputValue) -
                                            bidAmountID;
                                          if (decVal > currentBid) {
                                            bidInputOnChangeHandler(decVal);
                                          }
                                        }}
                                        className="d-flex justify-content-center align-items-center  incrementDecrementBtn"
                                      >
                                        <AiFillCaretDown />
                                      </button>
                                    </div>
                                  </Fragment>
                                </div>
                                <p className="dp-bid__hint" id="dp-bid-hint">
                                  {bidingExpired
                                    ? "Bidding is closed for this lot."
                                    : `Minimum next bid ${money(
                                        minimumNextBid
                                      )} · steps of ${money(incrementValue)}`}
                                </p>
                                {/* <button onClick={carAnimationHandler}>animate car</button> */}
                                {loadingPlaceBid ? (
                                  <div className="counter_place_bid_cont d-flex justify-content-center align-items-center w-100 m-1 p-2">
                                    <span
                                      className="counter_place_bid_cont_text"
                                      style={{ fontSize: "1.4rem" }}
                                    >
                                      Placing your bid...
                                    </span>
                                  </div>
                                ) : (
                                  <SlideButton
                                    disabled={loadingPlaceBid || bidingExpired}
                                    onEnd={placeBidHandler}
                                  />
                                )}
                                {bidStatus ? (
                                  <p
                                    className={`dp-bid__status${
                                      color ? " is-ok" : " is-error"
                                    }`}
                                    role="status"
                                  >
                                    {bidStatus}
                                  </p>
                                ) : null}

                                {/* <button
                                  className="counter_place_bid_cont d-flex justify-content-center align-items-center w-100 m-1 p-2"
                                  disabled={loadingPlaceBid || bidingExpired}
                                  onClick={placeBidHandler}
                                >
                                  <span
                                    className="counter_place_bid_cont_text"
                                    style={{ fontSize: "1.4rem" }}
                                  >
                                    {loadingPlaceBid
                                      ? `Bidding...`
                                      : `Place Bid`}
                                  </span>
                                </button> */}
                              </span>
                            ),
                          },
                          {
                            label: "Proxy bid",
                            component: (
                              <span>
                                <div className="place_bid_input_cont p-2">
                                  <input
                                    placeholder="Your maximum bid"
                                    aria-label="Maximum proxy bid in euro"
                                    aria-describedby="dp-proxy-hint"
                                    onChange={(e) =>
                                      bidInputOnChangeHandler2(e.target.value)
                                    }
                                  />
                                </div>
                                <p className="dp-bid__hint" id="dp-proxy-hint">
                                  We bid for you in {money(incrementValue)}{" "}
                                  steps up to this maximum.
                                </p>
                                {loadingPlaceBid ? (
                                  <div className="counter_place_bid_cont d-flex justify-content-center align-items-center w-100 m-1 p-2">
                                    <span
                                      className="counter_place_bid_cont_text"
                                      style={{ fontSize: "1.4rem" }}
                                    >
                                      Placing proxy bid…
                                    </span>
                                  </div>
                                ) : (
                                  <SlideButton
                                    disabled={false}
                                    onEnd={approxy_bid}
                                  />
                                )}
                              </span>
                            ),
                          },
                        ]}
                      />

                    </div>
                  </div>
                </div>
              </div>
            </div>

            <section className="dp-activity">
              <div className="dp-panel dp-activity__card">
                <header className="dp-history__head">
                  <div>
                    <p className="dp-history__eyebrow">Your position</p>
                    <h3 className="dp-history__title">
                      {auction_page.My_Bids_text}
                    </h3>
                  </div>
                </header>
                <dl className="dp-facts">
                  <div className="dp-fact">
                    <dt>{auction_page.My_Bids_text}</dt>
                    <dd>{graphData.my_bids ?? 0}</dd>
                  </div>
                  <div className="dp-fact">
                    <dt>{auction_page.Last_Bid_Amount_text}</dt>
                    <dd>
                      {graphData.last_bid ? money(graphData.last_bid) : "—"}
                    </dd>
                  </div>
                  <div className="dp-fact">
                    <dt>{auction_page.total_bids_text}</dt>
                    <dd>
                      {graphData.total_bidders ?? 0}
                      {bidderCount ? (
                        <button
                          type="button"
                          className="dp-fact__link"
                          onClick={() => setShowModal(true)}
                        >
                          View all
                        </button>
                      ) : null}
                    </dd>
                  </div>
                  <div className="dp-fact">
                    <dt>{auction_page.Price_text}</dt>
                    <dd>
                      <span className={`dp-reserve ${reserveTone}`}>
                        {auction_page.Reserved_text}
                      </span>
                    </dd>
                  </div>
                </dl>
              </div>

              <div className="dp-panel dp-activity__card">
                <header className="dp-history__head">
                  <div>
                    <p className="dp-history__eyebrow">Auction activity</p>
                    <h3 className="dp-history__title">Bid history</h3>
                  </div>
                  <button
                    type="button"
                    className="dp-graph-refresh"
                    onClick={fetchGraphHandler}
                    aria-label="Refresh bid history"
                  >
                    <MdAutorenew
                      size={18}
                      className={isRotating ? "rotate-icon" : ""}
                    />
                  </button>
                </header>
                <Graph
                  graphDataCb={(e) => setGraphData(e)}
                  ref={graphRef}
                  auction_id={product.auction_id}
                  user_id={user_id}
                />
              </div>

              <BidDetailsModal
                show={showModal}
                handleClose={handleClose}
                bidsDetail={product.bids_detail}
              />
            </section>

            <div className="dp-details dp-panel">
              <div className="dp-details__head">
                <p className="dp-details__eyebrow">Inspection & disclosures</p>
                <h2>Vehicle details</h2>
                <p className="dp-details__lead">
                  History report and lot disclosures for this vehicle.
                </p>
                <div className="dp-report">
                  <ClipboardDocumentCheckIcon width={42} />
                  <div className="dp-report__copy">
                    <h3>Vehicle History Report</h3>
                    <p>Powered by VMS</p>
                  </div>
                  <button
                    type="button"
                    className="dp-btn dp-btn--primary"
                    onClick={() => {
                      history.push({
                        pathname: "/dealers/dashbord/carreport",
                        search: `?id=${encodeURIComponent(productCode)}`,
                        state: {
                          product_code: productCode,
                          pdfSnapshot: {
                            product_name: product?.product_name || "",
                            year: product?.year || "",
                            Mileage: product?.Mileage || product?.mileage || "",
                            fuel_type: product?.fuel_type || "",
                            Transmission: product?.Transmission ?? "",
                            car_body_type: product?.car_body_type ?? "",
                            brands_image: product?.brands_image || "",
                          },
                        },
                      });
                    }}
                  >
                    View report
                  </button>
                </div>
                <h3 className="dp-details__subhead">Details & disclosures</h3>
              </div>
              <div className="dp-details__body">
                <VehicleDetailsGrid
                  title={"Car Details"}
                  bg={false}
                  details={vehicleDetails}
                />
                {product.product_accessory?.length > 0 && (
                  <VehicleDetailsGrid
                    title={"Car Accessories"}
                    bg={true}
                    details={product.product_accessory}
                  />
                )}
                {product.product_feature?.length > 0 && (
                  <VehicleDetailsGrid
                    title={"Car Features"}
                    bg={false}
                    details={product.product_feature}
                  />
                )}
                {product.product_description && (
                  <VehicleDetailsGrid
                    title={"Comments"}
                    bg={true}
                    comments={product.product_description}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
}

const mapStateToProps = (state) => ({
  user_id: state.auth.id,
  product: state.product.current,
  product_chk: state.product,
  product_new: state.product.newtimer,
  loadingDetails: state.product.fetchingCurrent,
  loadingPlaceBid: state.product.loadingPlaceBid,
  shiping_coast_: state.shiping,
  loading: state.shiping.loading,
  costData: state.shiping.data,
});
const mapDispatchToProps = (dispatch) => ({
  // get product list

  updatetimerdata: (data) =>
    dispatch({
      type: TIMER_DATA_UPDATE,
      payload: {
        data,
      },
    }),

  getProductDetail: (code) =>
    dispatch({
      type: PRODUCT_DETAIL,
      payload: {
        type: PRODUCT_DETAIL,
        method: GET,
        label: `${Labels.product_detail}${code}/`,
        hideOverlayLoader: true,
      },
    }),
  //
  // place bid
  place_bid: (data) =>
    dispatch({
      type: PLACE_BID,
      payload: {
        type: PLACE_BID,
        method: POST,
        label: `${Labels.place_bid}`,
        data,
        hideOverlayLoader: true,
      },
    }),
  //  get shiping cost
  shiping_cost_calclate: (data) =>
    dispatch({
      type: SHIPING_COST,
      payload: {
        type: SHIPING_COST,
        method: POST,
        label: `${Labels.shiping_cost}`,
        data,
        hideOverlayLoader: true,
      },
    }),
  //
  // approxy place bid
  approxy_BidNew: (data) =>
    dispatch({
      type: APPROXY_BID_NEW,
      payload: {
        type: APPROXY_BID_NEW,
        method: POST,
        label: `${Labels.approxy_Bid}`,
        data,
        hideOverlayLoader: true,
      },
    }),
  //
  toasterShow: (data) =>
    dispatch({
      type: TOASTER_SHOW,
      payload: {
        show: true,
        autoHide: true,
        ...data,
      },
    }),
});
export default connect(mapStateToProps, mapDispatchToProps)(ProductMain);
